import Debug from 'debug'
import { scaleQuestionScore } from '../../scale-question-score'
import { QuestionStateMachineData, QuestionState, QuestionAnswer,
         QuestionEvaluationResult, QuestionScore,
         determineEvaluationResult, resetQuestionAnswerAndEvaluation } from '../data'

const debug = Debug('answered-state')

export class AnsweredState {

  public readonly name = 'answered'

  stateEvents: {
    onEvaluate: () => void
    onReset: () => void
  }

  constructor(private data: QuestionStateMachineData,
              private questionScore: QuestionScore) {
  }
    
  updateState(state: QuestionState) {
    this.data.state = state
  }

  updateAnswer(answer: QuestionAnswer) {
    this.data.answer = answer;
  }

  updateResult(evaluation: QuestionEvaluationResult) {
    this.data.evaluation = this.determineEvaluation(evaluation, this.questionScore)
  }

  evaluate() {
    this.stateEvents.onEvaluate()
  }

  reset() {
    resetQuestionAnswerAndEvaluation(this.data, this.questionScore)
    this.stateEvents.onReset()
  }

  private determineEvaluation(evaluation: QuestionEvaluationResult, questionScore: QuestionScore) {

    const contentScore = {
      min: questionScore.content.min,
      max: questionScore.content.max,
      raw: evaluation.score
    }
    
    const score = scaleQuestionScore(contentScore, { min: questionScore.min, max: questionScore.max })
    debug(`scaled score is '${score}' based on content score`, contentScore)

    return {
      details: { score: score },
      result: determineEvaluationResult(score, questionScore)
    }
  }
}
